/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderSetupSubOfficesRoutingModule } from './builder-setup-sub-offices-routing.module';
import { SubOfficeDetailsComponent } from './components/sub-office-details/sub-office-details.component';
import { SubOfficeListComponent } from './components/sub-office-list/sub-office-list.component';
import { SubOfficeDetailsBusinessService } from './resources/sub-office-details-business.service';
import { SubOfficeListBusinessService } from './resources/sub-office-list-business.service';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),
    BuilderSetupSubOfficesRoutingModule,
  ],
  providers: [
    SubOfficeListBusinessService,
    SubOfficeDetailsBusinessService,
  ],
  declarations: [
    SubOfficeListComponent,
    SubOfficeDetailsComponent,
  ],
})
export class BuilderSetupSubOfficesModule {
}
